import '%app/js/common/services/configure-logrocket';
import hasCookieCategoryConsent from '%paysera_service_agreement/js/CookiesUserAgreement/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS } from '%paysera_service_agreement/js/CookiesUserAgreement/config/constants';
import LogRocket from 'logrocket';
import { getBuyerId } from '%evp_ticket_frontend/js/react/service/currentBuyer';

if (hasCookieCategoryConsent(CATEGORY_STATISTICS)) {
    LogRocket.identify(getBuyerId());
}
